import React, { Component } from 'react';
import { inject, observer } from 'mobx-react';
import { Button, Form, Row, Input, Col, Select} from 'antd';
@inject('connectionMonitorStore')
@observer
class SearchForm extends Component {
  state = {
  }
  formRef = React.createRef();
  componentDidMount() {
  }
  handleSearch=()=>{
    const { connectionMonitorStore } = this.props
    this.formRef.current.validateFields().then(fieldsValue => {
      connectionMonitorStore.onSearchMonitorAction(fieldsValue)
    }).catch(err => {})
  }
  render() {
    const formItemLayout = {
      labelCol: { span: 0},
      wrapperCol: { span: 23 },
    }
    return (
      <>
        <Row>
          <Col span={20}>
            <Form ref={this.formRef} labelCol={{ span: 8 }} initialValues={{
              channel: '',
              status: '',
              direction: '',
              channelType: '',
              partner: '',
              partnerComponent: '',
            }}>
              <Row>
                <Col span={4}>
                  <Form.Item name='channel' {...formItemLayout}>
                    <Input allowClear placeholder='Channel' />
                  </Form.Item>
                </Col>
                <Col span={4}>
                  <Form.Item name='status' {...formItemLayout}>
                    <Select placeholder="status" allowClear>
                      <Select.Option key='1' value='true'>Enable</Select.Option>
                      <Select.Option key='2' value='false'>Disable</Select.Option>
                    </Select>
                  </Form.Item>
                </Col>
                <Col span={4}>
                  <Form.Item name='direction' {...formItemLayout}>
                    <Select placeholder="Direction" allowClear>
                      <Select.Option key='1' value='true'>INBOUND</Select.Option>
                      <Select.Option key='2' value='false'>OUTBOUND</Select.Option>
                    </Select>
                  </Form.Item>
                </Col>
                <Col span={4}>
                  <Form.Item name='channelType' {...formItemLayout}>
                    <Input allowClear placeholder='Channel Type' />
                  </Form.Item>
                </Col>
                <Col span={4}>
                  <Form.Item name='partner' {...formItemLayout}>
                    <Input allowClear placeholder='Partner' />
                  </Form.Item>
                </Col>
                <Col span={4}>
                  <Form.Item name='partnerComponent' {...formItemLayout}>
                    <Input allowClear placeholder='Partner Component' />
                  </Form.Item>
                </Col>
              </Row>
            </Form>
          </Col>
          <Col span={4} style={{textAlign: 'right'}}>
            <Button style={{marginRight: 10}} onClick={this.handleSearch} type='primary'>Search</Button>
          </Col>
        </Row>
      </>
    );
  }
}

export default SearchForm;
